<template>
  <div>
    <vs-alert color="danger" title="User Not Found" :active.sync="user_not_found">
      <span>User record with id: {{ $route.params.id }} not found.</span>
      <span>
        <span>Check</span>
        <router-link :to="{ name: 'system-user-list' }" class="text-inherit underline">All Users</router-link>
      </span>
    </vs-alert>

    <div id="employee-data" v-if="employee_data">
      <div class="vx-row">
        <div class="vx-col lg:w-1/2 w-full">
          <vx-card :title="$t('users.account')" class="mb-base">
            <div class="vx-row">
              <div class="vx-col" id="avatar-col">
                <div class="img-container mb-4">
                  <vs-avatar :src="avatar" size="80px" class="mr-4" />
                </div>
              </div>

              <div class="vx-col flex-1 my-auto" id="account-info-col-1">
                <table>
                  <tr>
                    <td class="font-semibold">{{ $t('users.username') }}</td>
                    <td>{{ employee_data.user.username }}</td>
                  </tr>
                  <tr>
                    <td class="font-semibold">{{ $t('employees.status.status') }}</td>
                    <v-select
                      v-model="employee_data.status"
                      :clearable="false"
                      :options="statusOptions"
                      v-validate="'required'"
                      :data-vv-as="$t('employees.status.status')"
                      name="status"
                      :reduce="option => option.value"
                      :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    />
                    <div class="text-danger text-sm" v-show="errors.has('status')">
                      {{ errors.first('status') }}
                    </div>
                  </tr>
                </table>
              </div>
            </div>
            <div class="vx-col w-full flex" id="account-manage-buttons">
              <vs-button icon-pack="feather" icon="icon-edit" class="mr-4" @click="updateEmployee">{{
                $t('forms.update')
              }}</vs-button>
              <vs-button
                type="border"
                color="danger"
                icon-pack="feather"
                icon="icon-trash"
                @click="confirmDeleteRecord"
              >
                {{ $t('button.delete') }}
              </vs-button>
            </div>
          </vx-card>
        </div>
        <div class="vx-col lg:w-1/2 w-full">
          <vx-card :title="$t('users.information')" class="mb-base">
            <table>
              <tr>
                <td class="font-semibold">{{ $t('users.first_name') }}</td>
                <td>{{ employee_data.user.details.firstName }}</td>
              </tr>
              <tr>
                <td class="font-semibold">{{ $t('users.last_name') }}</td>
                <td>{{ employee_data.user.details.lastName }}</td>
              </tr>
              <tr>
                <td class="font-semibold">{{ $t('users.birthday') }}</td>
                <td>{{ employee_data.user.details.birthday | datetime }}</td>
              </tr>
              <tr>
                <td class="font-semibold">{{ $t('users.genders.gender') }}</td>
                <td>{{ $t(`users.genders.${employee_data.user.details.gender}`) }}</td>
              </tr>
              <tr>
                <td class="font-semibold">{{ $t('employees.phones') }}</td>
                <td v-if="employee_data.phones">{{ employee_data.phones.join(', ') }}</td>
              </tr>
            </table>
          </vx-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moduleEmployee from '@/store/employee/moduleEmployee.js'

export default {
  data() {
    return {
      employee_data: null,
      dataLocal: null,
      avatar: null,
      user_not_found: false,
      employee_not_found: false
    }
  },
  methods: {
    updateEmployee() {
      this.$store
        .dispatch('employee/editEmployee', { id: this.employee_data.id, data: this.dataLocal })
        .then(() => {
          this.$router.push({ name: 'business-employee-view', params: { id: this.employee_data.id } })
        })
    },
    confirmDeleteRecord() {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: this.$t('messages.are_you_sure'),
        text: this.$t('messages.confirm_delete', {
          title: `${this.$t('employees.employee')} ${this.employee_data.user.details.firstName} ${
            this.employee_data.user.details.lastName
          } با نام کاربری"${this.employee_data.user.username}"`
        }),
        accept: this.deleteRecord,
        acceptText: this.$t('button.delete'),
        cancelText: this.$t('button.cancel')
      })
    },
    deleteRecord() {
      this.$store.dispatch('employee/removeEmployee', this.employee_data.id).then(() => {
        this.showDeleteSuccess()
        this.$router.push({ name: 'business-employee-list' })
      })
    },
    showDeleteSuccess() {
      this.$vs.notify({
        color: 'success',
        title: this.$t('forms.successfully_deleted')
      })
    }
  },
  computed: {
    statusOptions() {
      return this.$store.getters['enum/selectOptions']('EmployeeStatus', 'employees.status')
    }
  },
  created() {
    this.$vs.loading()
    if (!moduleEmployee.isRegistered) {
      this.$store.registerModule('employee', moduleEmployee)
      moduleEmployee.isRegistered = true
    }
    const employeeId = this.$route.params.id
    this.$store
      .dispatch('employee/fetchEmployee', employeeId)
      .then(res => {
        this.employee_data = res.data.employee
        this.dataLocal = JSON.parse(JSON.stringify(res.data.employee))
        //get avatar
        if (this.employee_data.user.avatar) {
          this.$store.dispatch('file/downloadFile', this.employee_data.user.avatar).then(response => {
            this.avatar = response
          })
        }
      })
      .catch(err => {
        if (err.response.status === 404) {
          this.user_not_found = true
        }
      })
      .finally(() => this.$vs.loading.close())
  }
}
</script>

<style lang="scss">
#employee-data {
  table {
    td {
      vertical-align: top;
      min-width: 140px;
      padding-bottom: 0.8rem;
      word-break: break-all;
    }
  }
}
</style>
